import { PRIVILEGES } from "../utils/privileges";

export const ROLE_PERMISSIONS = {
  CUSTOMER_SUPPORT: {
    ADMIN: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.CALL_FARMER,
      PRIVILEGES.SEND_MESSAGE,
      PRIVILEGES.GENERATE_ACCOUNT_NUMBER,
      PRIVILEGES.EDIT_PROFILE,
      PRIVILEGES.GENERATE_STATEMENT,
      PRIVILEGES.KYC_DOCUMENTATION,
      PRIVILEGES.SET_DAILY_LIMIT,
      PRIVILEGES.GENERATE_PIN,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.BLOCK_FARMER,
      PRIVILEGES.RESET_BVN,
      PRIVILEGES.VIEW_MESSAGE_LOG,
      PRIVILEGES.COMPOSE_MESSAGE,
      PRIVILEGES.APPROVE_BULK_MESSAGE,
      PRIVILEGES.CREATE_TEMPLATE,
      PRIVILEGES.EDIT_TEMPLATE,
      PRIVILEGES.DELETE_TEMPLATE,
      PRIVILEGES.EDIT_COMPLAINT,
      PRIVILEGES.VIEW_COMPLAINTS,
      PRIVILEGES.VIEW_REQUESTS,
      PRIVILEGES.CHANGE_CALL_STATUS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.EDIT_ORDER,
      PRIVILEGES.SET_CALL_STATUS,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.ADD_DELIVERY_INFO,
      PRIVILEGES.UPDATE_DELIVERY,
      PRIVILEGES.CANCEL_ORDER,
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.REASSIGN_ORDER,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.VIEW_CAMPAIGN,
      PRIVILEGES.EDIT_CAMPAIGN,
      PRIVILEGES.CREATE_CAMPAIGN,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_USSD_SESSIONS,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_AGENTS,
    ],
    MEMBER: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.CALL_FARMER,
      PRIVILEGES.SEND_MESSAGE,
      PRIVILEGES.GENERATE_ACCOUNT_NUMBER,
      PRIVILEGES.EDIT_PROFILE,
      PRIVILEGES.GENERATE_STATEMENT,
      PRIVILEGES.KYC_DOCUMENTATION,
      PRIVILEGES.SET_DAILY_LIMIT,
      PRIVILEGES.GENERATE_PIN,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.BLOCK_FARMER,
      PRIVILEGES.RESET_BVN,
      PRIVILEGES.VIEW_MESSAGE_LOG,
      PRIVILEGES.COMPOSE_MESSAGE,
      PRIVILEGES.VIEW_COMPLAINTS,
      PRIVILEGES.VIEW_REQUESTS,
      PRIVILEGES.CHANGE_CALL_STATUS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.SET_CALL_STATUS,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.ADD_DELIVERY_INFO,
      PRIVILEGES.UPDATE_DELIVERY,
      PRIVILEGES.CANCEL_ORDER,
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.VIEW_CAMPAIGN,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_USSD_SESSIONS,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.VIEW_TEAMMATES,
    ],
  },
  SALES: {
    ADMIN: [
      PRIVILEGES.CREATE_FARMER_ORDER,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.VIEW_COOPERATIVE,
      PRIVILEGES.CREATE_COOPERATIVE,
      PRIVILEGES.EDIT_COOPERATIVE,
      PRIVILEGES.APPROVE_COOPERATIVE,
      PRIVILEGES.DEACTIVATE_COOPERATIVE,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.DEBIT_FARMER,
      PRIVILEGES.BULK_DEBIT,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.EDIT_ORDER,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.CONFIRM_ORDER,
      PRIVILEGES.REJECT_ORDER,
      PRIVILEGES.ASSIGN_ORDER,
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.REASSIGN_ORDER,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.ADD_PRODUCT,
      PRIVILEGES.EDIT_PRODUCT,
      PRIVILEGES.DISABLE_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.ADD_TO_STOCK,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.CREATE_STORE,
      PRIVILEGES.EDIT_STORE,
      PRIVILEGES.DISABLE_STORE,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.ADD_STORE_MANAGER,
      PRIVILEGES.ADD_STOCK_TO_STORE,
      PRIVILEGES.APPROVE_STOCK,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_INVENTORY,
      PRIVILEGES.REQUEST_NEW_STOCK,
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.VIEW_LOAN_OVERVIEW,
    ],
    ADHOC_ADMIN: [
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.DEBIT_FARMER,
      PRIVILEGES.VIEW_COOPERATIVE,
      PRIVILEGES.CREATE_COOPERATIVE,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.CONFIRM_ORDER,
      PRIVILEGES.REJECT_ORDER,
      PRIVILEGES.ASSIGN_ORDER,
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.ADD_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
    ],
    MEMBER: [
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.VIEW_COOPERATIVE,
      PRIVILEGES.CREATE_COOPERATIVE,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.CREATE_ORDER,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.CONFIRM_ORDER,
      PRIVILEGES.REJECT_ORDER,
      PRIVILEGES.ASSIGN_ORDER,
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.ADD_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
    ],
  },
  STORE: {
    ADMIN: [
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.REASSIGN_ORDER,
      PRIVILEGES.CHANGE_ORDER_STATUS,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.REQUEST_NEW_STOCK,
      PRIVILEGES.CONFIRM_STOCK,
      PRIVILEGES.ACCEPT_TRANSFER_REQUEST,
      PRIVILEGES.UPDATE_STOCK_REQUEST,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_INVENTORY,
    ],
    MEMBER: [
      PRIVILEGES.VIEW_MY_ASSIGNED_ORDER,
      PRIVILEGES.CHANGE_ORDER_STATUS,
      PRIVILEGES.ADD_NOTE,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.REQUEST_NEW_STOCK,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
      PRIVILEGES.CONFIRM_STOCK,
    ],
  },
  FINANCE: {
    ADMIN: [
      PRIVILEGES.GENERATE_STATEMENT,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_INVENTORY,
    ],
    MEMBER: [
      PRIVILEGES.GENERATE_STATEMENT,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
    ],
  },
  ADMINISTRATOR: {
    ADMIN: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_INVENTORY,
    ],
    MEMBER: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
    ],
  },
  TECH_SUPPORT: {
    ADMIN: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.BLOCK_FARMER,
      PRIVILEGES.VIEW_MESSAGE_LOG,
      PRIVILEGES.VIEW_COMPLAINTS,
      PRIVILEGES.VIEW_COOPERATIVE,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.VIEW_REQUESTS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.VIEW_CAMPAIGN,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_USSD_SESSIONS,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.INVITE_TEAMMATE,
      PRIVILEGES.DISABLE_TEAMMATE,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.CANCEL_INVITE,
      PRIVILEGES.RESEND_INVITE,
      PRIVILEGES.VIEW_INVENTORY,
    ],
    MEMBER: [
      PRIVILEGES.VIEW_FARMER_RECORDS,
      PRIVILEGES.VIEW_SINGLE_FARMER,
      PRIVILEGES.SUSPEND_FARMER,
      PRIVILEGES.BLOCK_FARMER,
      PRIVILEGES.VIEW_MESSAGE_LOG,
      PRIVILEGES.VIEW_COMPLAINTS,
      PRIVILEGES.VIEW_COOPERATIVE,
      PRIVILEGES.VIEW_DEBIT_RECORDS,
      PRIVILEGES.VIEW_REQUESTS,
      PRIVILEGES.VIEW_CALL_TO_ORDERS,
      PRIVILEGES.VIEW_ORDERS,
      PRIVILEGES.VIEW_RETAIL_RECORD,
      PRIVILEGES.VIEW_CAMPAIGN,
      PRIVILEGES.SEARCH_FOR_PRODUCT,
      PRIVILEGES.VIEW_OVERVIEW,
      PRIVILEGES.EXPORT_DATA,
      PRIVILEGES.VIEW_STORE,
      PRIVILEGES.VIEW_USSD_SESSIONS,
      PRIVILEGES.VIEW_TRANSACTIONS,
      PRIVILEGES.VIEW_TEAMMATES,
      PRIVILEGES.VIEW_INVENTORY,
    ],
  },
};
